import React, { useEffect, useState } from 'react';

//@ts-ignore
import * as styles from './filtered-content.module.css';
//@ts-ignoree
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import { ContentPreview } from './index';
import { getMediaData } from '../Global/DataUtils';
import { Publication } from '../Global/DataUtils/publicationQueries';
import { KontentStringValue } from '../../../types/KontentProps';
import RichText from '../Global/RichText';
import CtaLink from '../Global/CtaLink';
import ArrowLgButton from '../Global/ArrowLgButton';
import TagSelector from './TagSelector';
import { usehealthIcons } from '../Global/DataUtils/healthIcons';
import parse from 'html-react-parser';
import { isRichTextFieldBlank } from '../../global/utility';

interface Props {
    content?: ContentPreview[];
    cta_label?: KontentStringValue;
    centerItemPlacement: number;
    center_item?: Publication;
    featured_tiles?: Publication[];
    tags: { name: string; count: number }[];
    handleTagsClick: React.MouseEventHandler<HTMLButtonElement>;
    tagsClicked: string[];
    view_more_label?: KontentStringValue;
    headline: KontentStringValue;
    featured_tiles_headline?: KontentStringValue;
    reveal_descriptions?: KontentStringValue;
}

const ResearchExploration: React.FC<Props> = ({
    content,
    cta_label,
    centerItemPlacement,
    center_item,
    featured_tiles,
    tags,
    handleTagsClick,
    tagsClicked,
    view_more_label,
    headline,
    featured_tiles_headline,
    reveal_descriptions,
}) => {
    const icons = usehealthIcons();
    const formattedIcons = icons.map(({ node }) => ({
        url: node?.elements?.icon?.value[0]?.url,
        name: node?.elements?.icon?.value[0]?.name,
        codename: node?.system?.codename,
    }));

    let tiles: ContentPreview[] =
        featured_tiles != undefined ? featured_tiles : [];
    const backfillContent = 3 - tiles.length;
    let slicedContent =
        content != undefined ? content?.slice(0, backfillContent) : [];
    tiles = [...tiles, ...slicedContent];
    const [truncatedStates, setTruncatedStates] = useState({});

    const carouselContent = tiles.slice(0, 3);
    const additionalContent = content?.slice(backfillContent);
    const breakpoints = useBreakpoint();

    const [currentMobileItem, setCurrentMobileItem] = useState(0);
    const arrowStrokeColor = '#f06623';

    const handlePrevClick = (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
        const newItem = currentMobileItem - 1;

        setCurrentMobileItem(newItem);
    };

    const handleNextClick = (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
        const newItem = currentMobileItem + 1;

        setCurrentMobileItem(newItem);
    };
    useEffect(() => {
        setTruncatedStates({});
    }, [tagsClicked]);
    const renderCarouselCard = (
        contentItem: Publication,
        contentIdx: number
    ) => {
        if (breakpoints.md || contentIdx === currentMobileItem) {
            const contentElements = contentItem.elements;
            const image = getMediaData(contentElements.image);
            return (
                <div key={contentIdx} className={styles.newsCarouselCard}>
                    {image?.url && (
                        <div className={styles.image}>
                            <picture>
                                <img
                                    src={image?.url}
                                    alt={image?.description || image?.name}
                                />
                            </picture>
                        </div>
                    )}

                    <div className={styles.newsBody}>
                        <div className={styles.newsTitle}>
                            {contentElements.title.value}
                        </div>

                        <div className={styles.summary}>
                            {RichText(contentElements.short_description)}
                        </div>
                        <div className={styles.newsSource}>
                            {contentElements.source.value}
                        </div>
                    </div>

                    {contentElements.url_location.value && (
                        <div className={styles.newsCtaContainer}>
                            <CtaLink
                                href={contentElements.url_location.value}
                                target="_new"
                            >
                                {cta_label?.value}
                            </CtaLink>
                        </div>
                    )}

                    {!contentElements.url_location.value &&
                        contentElements.document.value[0] && (
                            <div className={styles.newsCtaContainer}>
                                <CtaLink
                                    href={
                                        contentElements.document.value[0]
                                            .elements.document.value[0]?.url
                                    }
                                    target="_new"
                                >
                                    {cta_label?.value}
                                </CtaLink>
                            </div>
                        )}
                </div>
            );
        }
    };

    const renderCenterContent = () => {
        const contentElements = center_item?.elements;
        const image = getMediaData(contentElements?.image);

        if (!contentElements) {
            return null;
        }

        return (
            <div className={styles.newsCenterCard}>
                {image?.url && (
                    <div className={styles.image}>
                        <picture>
                            <img
                                src={image?.url}
                                alt={image?.description || image?.name}
                            />
                        </picture>
                    </div>
                )}

                <div className={styles.newsCenterBody}>
                    <div>
                        <div className={styles.newsSource}>
                            {contentElements.source.value}
                            {contentElements.publication_date.value && ` | `}
                            {contentElements.publication_date.value}
                        </div>
                        <div className={styles.newsTitle}>
                            {contentElements.title.value}
                        </div>
                    </div>
                    <div className={styles.summary}>
                        {RichText(contentElements.short_description)}
                    </div>
                    {contentElements.url_location.value && (
                        <div className={styles.newsCtaContainer}>
                            <CtaLink
                                href={contentElements.url_location.value}
                                target="_new"
                            >
                                {cta_label?.value}
                            </CtaLink>
                        </div>
                    )}

                    {!contentElements.url_location.value &&
                        contentElements.document.value[0] && (
                            <div className={styles.newsCtaContainer}>
                                <CtaLink
                                    href={
                                        contentElements.document.value[0]
                                            .elements.document.value[0]?.url
                                    }
                                    target="_new"
                                >
                                    {cta_label?.value}
                                </CtaLink>
                            </div>
                        )}
                </div>
            </div>
        );
    };

    const handleShowMoreClick = (contentIdx: number) => {
        setTruncatedStates((prevStates) => ({
            ...prevStates,
            [contentIdx]: false,
        }));
    };

    const renderRow = (
        contentItem: Publication,
        contentIdx: number,
        filteredIcons: []
    ) => {
        const contentElements = contentItem.elements;
        const description =
            parse(contentElements?.short_description?.value)?.props?.children ||
            '';
        const maxLength = 88;

        return (
            <React.Fragment key={contentIdx}>
                {centerItemPlacement === contentIdx && renderCenterContent()}

                <div className={styles.researchRow}>
                    <a
                        href={
                            contentElements.url_location.value ||
                            contentElements.document?.value[0]?.elements
                                ?.document.value[0]?.url
                        }
                        target="_new"
                    >
                        <div className={styles.researchRowBody}>
                            <div className={styles.researchRowTitle}>
                                {contentElements.title.value}
                            </div>

                            <div className={styles.ResearchSource}>
                                {contentElements.source?.value}
                                {contentElements.publication_date.value &&
                                    ` | `}
                                {contentElements.publication_date.value}
                            </div>
                        </div>
                    </a>
                    <div className={styles.icons}>
                        {filteredIcons !== null &&
                            filteredIcons.length > 0 &&
                            filteredIcons.map((icon, iconIdx) => {
                                return (
                                    <div key={iconIdx}>
                                        <picture>
                                            <img
                                                className={styles.icon}
                                                src={icon.url}
                                                alt={icon.name}
                                            />
                                        </picture>
                                    </div>
                                );
                            })}
                    </div>
                    {
                        <div className={styles.shortDescription}>
                            {contentElements?.short_description?.value &&
                                !isRichTextFieldBlank(contentElements.short_description.value) && (
                                    <div>
                                        {!breakpoints.sm
                                            ? description &&
                                              (truncatedStates[contentIdx] !==
                                              false ? (
                                                  <>
                                                      {parse(
                                                          `${description.slice(
                                                              0,
                                                              maxLength
                                                          )} `
                                                      )}
                                                      <span
                                                          className={
                                                              styles.showMore
                                                          }
                                                          onClick={() =>
                                                              handleShowMoreClick(
                                                                  contentIdx
                                                              )
                                                          }
                                                      >
                                                          ...
                                                          {
                                                              reveal_descriptions?.value
                                                          }
                                                      </span>
                                                  </>
                                              ) : (
                                                  parse(description)
                                              ))
                                            : parse(
                                                  contentElements
                                                      .short_description.value
                                              )}
                                    </div>
                                )}
                        </div>
                    }
                </div>
            </React.Fragment>
        );
    };

    return (
        <div className={styles.newsExploration}>
            {featured_tiles_headline && featured_tiles_headline.value && (
                <h2 className={styles.headline}>
                    {featured_tiles_headline.value}
                </h2>
            )}

            {carouselContent && (
                <div className={styles.researchCorouselContainer}>
                    {currentMobileItem != 0 && !breakpoints.md ? (
                        <ArrowLgButton
                            direction="left"
                            strokeColor={arrowStrokeColor}
                            handleClick={handlePrevClick}
                            className={styles.carouselPrev}
                        />
                    ) : null}
                    <div className={styles.newsCarousel}>
                        {carouselContent.map((contentItem, itemIdx) => {
                            return renderCarouselCard(
                                contentItem as Publication,
                                itemIdx
                            );
                        })}
                    </div>
                    {currentMobileItem != carouselContent?.length - 1 &&
                    !breakpoints.md ? (
                        <ArrowLgButton
                            direction="right"
                            strokeColor={arrowStrokeColor}
                            handleClick={handleNextClick}
                            className={styles.carouselNext}
                        />
                    ) : null}
                    {!breakpoints.md && (
                        <div className={styles.dots}>
                            {renderDots(
                                carouselContent?.length,
                                currentMobileItem
                            )}
                        </div>
                    )}
                </div>
            )}
            <h2 className={styles.headline}>{headline.value}</h2>
            <TagSelector
                tags={tags}
                handleTagsClick={handleTagsClick}
                tagsClicked={tagsClicked}
                view_more_label={view_more_label}
            />
            {additionalContent && (
                <div className={styles.researchRows}>
                    {additionalContent.map((contentItem, itemIdx) => {
                        const researchTypes =
                            contentItem.elements?.research_type?.value.map(
                                (item) => item.codename
                            ) || [];
                        const filteredIcons = getIcons(
                            formattedIcons || [],
                            researchTypes
                        );

                        return renderRow(
                            contentItem as Publication,
                            itemIdx,
                            filteredIcons
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default ResearchExploration;

function getIcons(icons, categories) {
    if (categories.length === 0) {
        return null;
    }

    const matchedIcons = icons.filter((icon) =>
        categories.includes(icon.codename)
    );

    if (matchedIcons.length === 0) {
        return null;
    }

    return matchedIcons;
}

function renderDots(dotsToShow: number, currentPosition: number) {
    let dots = [];

    for (let i = 0; i < dotsToShow; i++) {
        dots.push(
            <span
                key={i}
                style={currentPosition == i ? { background: '#ccc' } : {}}
            ></span>
        );
    }

    return dots;
}
